import { Button } from '@chakra-ui/core';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmPopover } from '../../../../common/ConfirmPopover/ConfirmPopover';
import { QuestionnaireTemplateStore } from '../../store/questionnaireTemplateModel';

export const QuestionClearButton = React.memo(function QuestionClearButton() {
  const { t } = useTranslation('questionnaireTemplate');
  const reset = QuestionnaireTemplateStore.useStoreActions((actions) => actions.reset);
  const isCreatingTemplate = QuestionnaireTemplateStore.useStoreState((s) => s.isCreatingTemplate);
  const hasErrors = QuestionnaireTemplateStore.useStoreState((state) => state.hasErrors);
  const hasNoElements = QuestionnaireTemplateStore.useStoreState((state) => isEmpty(state.entities.elements));

  const isDisabled = hasErrors || isCreatingTemplate || hasNoElements;

  const handleClear = React.useCallback(() => {
    if (isDisabled) return;

    reset();
  }, [reset, isDisabled]);

  return (
    <ConfirmPopover message={t('formBuilder.elementList.clearMessage')} onConfirm={handleClear}>
      <Button variant="outline" size="sm" fontSize={12} colorScheme="red" isDisabled={isDisabled}>
        {t('formBuilder.elementList.clearButton')}
      </Button>
    </ConfirmPopover>
  );
});
